import type { IUserDetailsEntity } from '@intigral/domain';
import { STORE_NAME } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import type { IAuthService } from '@intigral/domain/lib/application/services/AuthService';
import { container } from '@intigral/domain/lib/DataDomain';
import { log } from '@intigral/utils';
import { set } from '@intigral/utils/lib/browser-storage/localStorage';
import { buildGuestLoginUrl, buildGuestPublicConfigUrl, getGuestIdentityAppKey } from './api';
import { normalizeGuestLoginResponse, parseGuestPublicConfig } from './normalizeLoginResponse';
import type { PublicConfigBody } from './types';

function authService(): IAuthService {
    return container.resolve<IAuthService>(DI.SERVICES.IAuthService);
}

export async function guestBrowseLogin(): Promise<IUserDetailsEntity | null> {
    try {
        const publicConfigUrl = buildGuestPublicConfigUrl();
        const guestLoginUrl = buildGuestLoginUrl();

        if (!publicConfigUrl || !guestLoginUrl) {
            return null;
        }

        const publicConfigBody = (await authService().getGuestPublicConfig(publicConfigUrl)) as PublicConfigBody | null;
        if (!publicConfigBody) {
            return null;
        }

        const guestPublicConfig = parseGuestPublicConfig(publicConfigBody, 'WEB');
        if (!guestPublicConfig) {
            return null;
        }

        set(STORE_NAME.GUEST_PUBLIC_CONFIG, {
            anonymous_user: guestPublicConfig.anonymousUser,
            envKey: guestPublicConfig.envKey,
            client: guestPublicConfig.client,
        });

        const loginJson = await authService().loginGuest(guestLoginUrl, {
            username: guestPublicConfig.anonymousUser,
            envKey: guestPublicConfig.envKey,
            client: guestPublicConfig.client,
        });

        const loginError = (loginJson as { error?: { msg?: string; code?: string } } | null)?.error;
        if (!loginJson || loginError) {
            return null;
        }

        const user = normalizeGuestLoginResponse(loginJson, {
            anonymousUsername: guestPublicConfig.anonymousUser,
            envKey: guestPublicConfig.envKey,
        });

        return user;
    } catch (error) {
        return null;
    }
}
